import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Role information", -1)
const _hoisted_3 = { class: "flex flex-col mt-8" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold mb-4" }, "Name", -1)
const _hoisted_6 = {
  class: "rounded px-2 py-4",
  style: {"background-color":"#eff0f6"}
}
const _hoisted_7 = { class: "flex flex-col mt-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold mb-4" }, "Department", -1)
const _hoisted_9 = {
  class: "rounded px-2 py-4 capitalize",
  style: {"background-color":"#eff0f6"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold mb-4 mt-8" }, "Responsibilities", -1)
const _hoisted_11 = { class: "flex flex-col mt-8" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold mb-4" }, "Requirements", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold mt-8" }, "Benefits", -1)
const _hoisted_14 = {
  class: "flex flex-col rounded px-2 py-4 mt-4",
  style: {"background-color":"#eff0f6"}
}
const _hoisted_15 = { class: "w-52" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bullets = _resolveComponent("Bullets")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.talent.position.name), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.talent.position.department), 1)
      ]),
      _hoisted_10,
      _createVNode(_component_Bullets, {
        disabled: true,
        modelValue: _ctx.displayRespAndReqs.responsibilities,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayRespAndReqs.responsibilities) = $event)),
        name: "responsibilities",
        placeholder: "Responsibilities..."
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode(_component_Bullets, {
        disabled: true,
        modelValue: _ctx.displayRespAndReqs.requirements,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.displayRespAndReqs.requirements) = $event)),
        name: "responsibilities",
        placeholder: "Responsibilities..."
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talent.position.benefits, (benefit, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["flex flex-row", { 'mt-4': i > 0 }])
        }, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(benefit.name), 1),
          _createElementVNode("span", null, "$" + _toDisplayString((benefit.value / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })) + " USD", 1)
        ], 2))
      }), 128))
    ])
  ]))
}